import { render, staticRenderFns } from "./ArtificialPaperSetScore.vue?vue&type=template&id=d0b87d4a&scoped=true"
import script from "./ArtificialPaperSetScore.vue?vue&type=script&lang=js"
export * from "./ArtificialPaperSetScore.vue?vue&type=script&lang=js"
import style0 from "./ArtificialPaperSetScore.vue?vue&type=style&index=0&id=d0b87d4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b87d4a",
  null
  
)

export default component.exports